module.exports = __webpack_public_path__ + "static/img/70130C_2_C_20200811_LC.672471b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/70130C_2_C_20200811_LC.png
// module id = v7nz
// module chunks = 0